//=================================================
//    summary: DCP Vider Player Window -- Hook
//
//    remarks: 000 Tim 2021/12/14 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssViderPlayerWindow from './ViderPlayerWindow.module.scss'

import {LoadingMask, GlobalLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mstrIframeUrl = ""
// #endregion Member Variables


const COMP_NAME = "ViderPlayerWindow"

function ViderPlayerWindow(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [isVideoFullScreenMode, setIsVideoFullScreenMode] = useState(false)

    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)

    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mstrIframeUrl = GetIframeUrl()

        GlobalLibs.AddWindowMessageEvent(MessageReceived)

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            mblnInitialized = false

            GlobalLibs.RemoveWindowMessageEvent()
            setIsVideoFullScreenMode(false)
        }
    }, [props.Arguments])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objCallbackData = {
            "Action": "CloseShowViderPlayerWindow"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: Iframe 讀取完畢
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function IframeOnLoaded(e)
    {
        console.log(COMP_NAME + ".IframeOnLoaded")

        CloseLoadingMask()

        CallBCVideoPlayerAreYouReady(e.target)
    } // end of IframeOnLoaded

    /*===========================================
    summary: Video 準備好可以播
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function VideoCanPlayEventHandler()
    {
        console.log(COMP_NAME + ".VideoCanPlayEventHandler")

        // // 關閉 當Video Can Play前 需顯示Loading Mask 避免看起來只有白色的框底
        // CloseLoadingMask() 
    } // end of VideoCanPlayEventHandler

    /*===========================================
    summary: Video 播放結束
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function VideoEndedEventHandler()
    {
        console.log(COMP_NAME + ".VideoEndedEventHandler")

        if (window.gSession.App.InApp)
        {
            // Video結束，也要關閉全螢幕    Tim21.09.02
            setIsVideoFullScreenMode(false)
        }
    } // end of VideoEndedEventHandler

    /*===========================================
    summary: Video 按下 全螢幕按鈕 通知事件
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function VideoEnterFullScreenHandler()
    {
        console.log(COMP_NAME + ".VideoEnterFullScreenHandler")

        if (window.gSession.App.InApp)
        {
            setIsVideoFullScreenMode(true)
        }
    } // end of VideoEnterFullScreenHandler

    /*===========================================
    summary: Video 離開 全螢幕按鈕 通知事件
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function VideoExitFullScreenHandler()
    {
        console.log(COMP_NAME + ".VideoExitFullScreenHandler")

        if (window.gSession.App.InApp)
        {
            setIsVideoFullScreenMode(false)
        }
    } // end of VideoExitFullScreenHandler
    // #endregion Other EventHandler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask
    // #endregion LoadingMask and Alert Functions

    // #region MessageReceived
    /*===========================================
    summary: 接收 BCVideoPlayer 事件
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function MessageReceived(Event)
    {
        console.log(COMP_NAME + ".MessageReceived: ", Event)

        // get the origin of event
        let strEventOrigin = Event.origin

        let strAppWebDomain = PackageVariablesLibs.SysConfig.AppWebDomain
        if (window.gConfig.ForChina)
        {
            // CN Web 讀 中國伺服器 遠端 BCVideoPlayer       Tim21.01.06
            strAppWebDomain = window.gConfig.AppWebDomain4VideoCN
        }

        if (
            (strEventOrigin !== strAppWebDomain) &&
            (strEventOrigin !== "file://")
            )
        {
            // e.g. 從Google Classroom進來的 就不處理
            console.log("Not from my parent, cannot accept")
        }
        else
        {
            console.log("Event.data: ", Event.data)
            console.log("typeof(Event.data): ", typeof (Event.data))

            if (typeof (Event.data) === 'object')
            {
                if (Event.data.source.indexOf('react-devtools') !== -1)
                {
                    return
                }
            }
            if (
                (typeof (Event.data) === 'string') &&
                (Event.data === "")
                )
            {
                return
            }

            let objCallData = JSON.parse(Event.data, true)
            /* 特別注意，
            Prelude的Menu也會trigger message, typeof 會是 function
            Sencha touch 的 DatePicker 也會trigger message, typeof 會是 function
             * 還不知道原因
             */

            console.log("typeof(objCallData): ", typeof (objCallData))

            if (typeof (objCallData) === 'object')
            {
                // note that, Init Hand Shaking 時還沒有DCPCross <- richard: 用top，現階段不需要HandShaking
                // check if the message is from my parent
                // if (strEventOrigin !== mstrWebParentDomain)
                console.log("strEventOrigin: ", strEventOrigin)
                // console.log("AppWebDomain: ", PackageVariablesLibs.SysConfig.AppWebDomain)


                console.log("objCallData.Credential: ", objCallData.Credential)
                if (objCallData.Credential !== window.gSession.Acc.Credential)
                {
                    console.log("credential not match")
                    // credential not match
                    // error 不做事
                }
                else
                {
                    console.log("objCallData.Func: ", objCallData.Func)
                    console.log("objCallData: ", objCallData)

                    switch (objCallData.Func)
                    {
                        case "VideoCanPlay":
                            VideoCanPlayEventHandler()
                            break
                        case "VideoEnded":
                            VideoEndedEventHandler()
                            break
                        case "VideoEnterFullScreen":
                            VideoEnterFullScreenHandler()
                            break
                        case "VideoExitFullScreen":
                            VideoExitFullScreenHandler()
                            break
                        default:
                            break
                    } // end of switch (objCallData.Func)
                }

            }
        }
    } // end of MessageReceived
    // #endregion MessageReceived

    // #region Call Iframe
    /*===========================================
    summary: 呼叫 Video Player Are You Ready
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function CallBCVideoPlayerAreYouReady(iFrameRef)
    {
        console.log(COMP_NAME + ".CallBCVideoPlayerAreYouReady: ", iFrameRef)

        let objMessage = {
            "Credential": window.gSession.Acc.Credential,
            "Func": "AreYouReady",
            "Args": {
                "VideoDef": {
                    "VideoUrl": props.Arguments.VideoUrl,
                    "PosterUrl": props.Arguments.PosterUrl
                }
            }
        }

        let strMessage = JSON.stringify(objMessage)

        // iFrameRef.contentWindow.postMessage(strMessage, PackageVariablesLibs.SysConfig.AppWebDomain)

        // if (window.gSession.App.InApp)
        // {
        //     let strTargetDomain = window.location.protocol + "//" + window.location.hostname
        //     iFrameRef.contentWindow.postMessage(strMessage, strTargetDomain);
        // }
        // else
        // {
        let strAppWebDomain = PackageVariablesLibs.SysConfig.AppWebDomain
        if (window.gConfig.ForChina)
        {
            // CN Web 讀 中國伺服器 遠端 BCVideoPlayer       Tim21.01.06
            strAppWebDomain = window.gConfig.AppWebDomain4VideoCN
        }

        iFrameRef.contentWindow.postMessage(strMessage, strAppWebDomain)
        // }
    } // end of CallBCVideoPlayerAreYouReady
    // #endregion Call Iframe

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        if (
            (typeof (props.Arguments) !== 'undefined') &&
            (props.Arguments !== null) &&
            (typeof (props.Arguments.VideoUrl) !== 'undefined') &&
            (props.Arguments.VideoUrl !== null) &&
            (props.Arguments.VideoUrl !== "")
            )
        {
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadVideoData)
        }
    } // end of PaintedMe

    /*===========================================
    summary: 取得 Iframe Url
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function GetIframeUrl()
    {
        let strIframeUrl = ""

        let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)
        let strInApp4QueryString = window.Globals.GetQueryString4InApp()
        let strSupportLang = "en-US"
        let strTargetLang = "zh-CN"
        let strQueryString = "Credential=" + window.gSession.Acc.Credential

        // Tim21.12.15
        // App 這邊 會 抓到 file://
        // 出現 console.log 會出現 warnings
        // Blocked a frame with origin "file://" from accessing a frame with origin "https://servicedev.betterchinese.com".  The frame requesting access has a protocol of "file", the frame being accessed has a protocol of "https". Protocols must match.
        let strTargetDomain = window.location.protocol + "//" + window.location.hostname

        if (
            (typeof (window.location.port) !== 'undefined') &&
            (window.location.port !== null) &&
            (window.location.port !== "")
            )
        {
            strTargetDomain += ":" + window.location.port
        }

        console.log("strTargetDomain: ", strTargetDomain)
        // console.log("window.location: ", window.location)
        // console.log("window.gSession.App.Env:", window.gSession.App.Env)
        // console.log("intEnv: ", intEnv)
        // console.log("strInApp4QueryString: ", strInApp4QueryString)


        strTargetDomain = encodeURIComponent(strTargetDomain)
        strQueryString = strQueryString + "&TargetDomain=" + strTargetDomain
        strQueryString = strQueryString + "&Env=" + intEnv.toString()           //"2", window.gSession.App.Env
        strQueryString = strQueryString + strInApp4QueryString
        strQueryString = strQueryString + "&SysType=" + window.gSession.App.SysType.toString()
        strQueryString = strQueryString + "&SupportLang=" + strSupportLang
        strQueryString = strQueryString + "&TargetLang=" + strTargetLang

        // if (window.gSession.App.InApp)
        // {
        //     // App 讀./resources內的 BCVideoPlayer
        //     strIframeUrl = "./Libs/BCVideoPlayer/index.html?" + strQueryString
        // }
        if (window.gConfig.ForChina)
        {
            // CN Web 讀 中國伺服器 遠端 BCVideoPlayer       Tim21.01.06
            strIframeUrl = window.gConfig.AppWebDomain4VideoCN + "/BCVideoPlayer/?" + strQueryString
        }
        else
        {
            // Web 讀遠端 BCVideoPlayer
            strIframeUrl = PackageVariablesLibs.SysConfig.AppWebDomain + "/BCVideoPlayer/?" + strQueryString
        }

        console.log("GetIframeUrl: strIframeUrl: ", strIframeUrl)

        return strIframeUrl
    } // end of GetIframeUrl
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 此視窗 的 Cls
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function GetMainCls(StateIsVideoFullScreenMode)
    {
        let objCls = cssViderPlayerWindow.divMain

        if (StateIsVideoFullScreenMode)
        {
            objCls = cssViderPlayerWindow.divMainFullScreen
        }

        return objCls
    } // end of GetMainCls

    /*===========================================
    summary: 取得 此視窗 內容 的 Cls
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function GetContentCls(StateIsVideoFullScreenMode)
    {
        let objCls = cssViderPlayerWindow.divContent

        if (StateIsVideoFullScreenMode)
        {
            objCls = cssViderPlayerWindow.divContentFullScreen
        }

        return objCls
    } // end of GetContentCls

    /*===========================================
    summary: 取得 此Iframe 的 Cls
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function GetIframePlayerCls(StateIsVideoFullScreenMode)
    {
        let objCls = cssViderPlayerWindow.iframePlayer

        if (StateIsVideoFullScreenMode)
        {
            objCls = cssViderPlayerWindow.iframePlayerFullScreen
        }

        return objCls
    } // end of GetIframePlayerCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: Title 顯示Component  
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function ComponentTitle({ PropsTitle })
    {
        let strTitle = ""
        if (
            (typeof (PropsTitle) !== 'undefined') &&
            (PropsTitle !== null) &&
            (PropsTitle !== "")
            )
        {
            strTitle = PropsTitle
        }

        return (
            <div className={cssViderPlayerWindow.divTitle}>
                {strTitle}
            </div>
        )
    } // end of ComponentTitle
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function RenderContentWrapper(StateIsVideoFullScreenMode, VideoUrl)
    {
        if (VideoUrl !== "")
        {
            return (
                <div className={GetContentCls(StateIsVideoFullScreenMode)}>
                    <iframe title="IframeVideoPlayer" onLoad={IframeOnLoaded}
                        className={GetIframePlayerCls(StateIsVideoFullScreenMode)}
                        src={mstrIframeUrl}
                        scrolling="no" allow="autoplay;" allowFullScreen />
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function RenderTopToolWrapper(StateIsVideoFullScreenMode)
    {
        if (!StateIsVideoFullScreenMode)
        {
            return (
                <div className={cssViderPlayerWindow.divTopTool}>
                    <div className={cssViderPlayerWindow.btnCloseMain} onClick={() => CloseOnTapHandler()}>
                        <div className={cssViderPlayerWindow.btnCloseIcon}/>
                    </div>

                    <ComponentTitle PropsTitle={props.Arguments.Title} />
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssViderPlayerWindow.divMask}>
                <div className={GetMainCls(isVideoFullScreenMode)}>
                    {RenderTopToolWrapper(isVideoFullScreenMode)}

                    {RenderContentWrapper(isVideoFullScreenMode, props.Arguments.VideoUrl)}
                </div>

                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default ViderPlayerWindow